import React from 'react';
import { Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { usePublicData } from '../lib/publicData';

export const CancellationPolicy = ({ policy, id, includeAll = false }) => !policy?.cancellation_early ? null : <section data-testid={`${id}-cancellation`} className="text-sm leading-relaxed mt-5">
  <h3 className="font-medium mb-3">Annulation et report</h3>
  <ul className="list-disc pl-5 space-y-2">
    <li data-testid={`${id}-cancellation-early`}>{policy.cancellation_early}</li>
    {(includeAll || !policy.is_christmas) && <li data-testid={`${id}-cancellation-late`}>{policy.cancellation_late}</li>}
    {(includeAll || policy.is_christmas) && <li data-testid={`${id}-cancellation-christmas`}>{policy.cancellation_christmas}</li>}
  </ul>
</section>;

export const LatenessPolicy = ({ policy, id, includeAll = false, includeCancellation = true }) => !policy ? null : <section data-testid={`${id}-policy`} className="text-sm leading-relaxed">
  <h3 className="flex items-center gap-2 font-medium mb-3"><Clock size={17} aria-hidden="true"/>{policy.title}</h3>
  <ul className="list-disc pl-5 space-y-2">
    <li data-testid={`${id}-policy-rule`}>{policy.rule}</li>
    {(includeAll || !policy.is_christmas) && <li data-testid={`${id}-policy-extension`}>{policy.extension}</li>}
    {(includeAll || policy.is_christmas) && <li data-testid={`${id}-policy-christmas`}>{policy.christmas_exception}</li>}
  </ul>
  {includeCancellation && <CancellationPolicy policy={policy} id={id} includeAll={includeAll}/>}
</section>;

const usePolicy = () => {
  const initial = usePublicData();
  const [policy, setPolicy] = React.useState(initial.booking_policy || null);
  React.useEffect(() => { api.get('/booking-policy').then(r => setPolicy(r.data)).catch(() => {}); }, []);
  return policy;
};
export const PublicLatenessPolicy = ({ id, includeCancellation = true }) => <LatenessPolicy policy={usePolicy()} id={id} includeAll includeCancellation={includeCancellation}/>;
export const PublicCancellationPolicy = ({ id }) => <CancellationPolicy policy={usePolicy()} id={id} includeAll/>;

export const LatenessConsent = ({ policy, accepted, onChange, includeAll = false }) => <div className="mt-6 border-y border-white/20 py-6" data-testid="lateness-consent">
  <LatenessPolicy policy={policy} id="booking" includeAll={includeAll}/>
  <label className="mt-5 flex items-start gap-3 cursor-pointer" htmlFor="late-policy-accept">
    <input id="late-policy-accept" data-testid="late-policy-accept" type="checkbox" required checked={accepted} onChange={e => onChange(e.target.checked)} className="mt-1 h-5 w-5 shrink-0 accent-[#D6A86C]"/>
    <span className="text-sm" data-testid="late-policy-acceptance-label">{policy.acceptance_label}</span>
  </label>
  <Link to="/conditions-generales" target="_blank" rel="noopener noreferrer" className="mt-3 inline-block underline text-sm" data-testid="booking-terms-link">Conditions générales</Link>
</div>;